import iconOne from '../../assets/features/1.png';
import iconTwo from '../../assets/features/2.png';
import iconThree from '../../assets/features/3.png';
import iconFour from '../../assets/features/4.png';

const featuresData = [
    {
        'icon': iconOne,
        'title': 'Segurança em primeiro lugar',
        'description': 'Priorizamos a segurança com exames de saúde e muito mais'
    },
    {
        'icon': iconTwo,
        'title': 'Aceitamos seguros',
        'description': 'Estamos na rede de grandes seguradoras como Seguro1, Seguro2 e Seguro3.'
    },
    {
        'icon': iconThree,
        'title': 'Odontologia completa',
        'description': 'Nossa clínica oferece todos os serviços odontológicos, de exames a implantes e facetas.'
    },
    {
        'icon': iconFour,
        'title': 'Sem julgamentos',
        'description': 'De problemas com fio dental a dentes sensíveis, toda boca é bem-vinda.'
    }
]

export default featuresData;
